// extracted by mini-css-extract-plugin
export default {"container":"content-row_container__EHpsz","labelContainer":"content-row_labelContainer__96Ohq","valueContainer":"content-row_valueContainer__3Pas0"};